<template>
  <div class="animated fadeIn bgLoader" >
    <div class="bgLoader-middle">
      <!-- <h1>COMING SOON</h1> -->
      <div class="loader">
      	<p class="box-img-loader"></p>
      	<img src="img/favicon.png">
      	<span>Give us a minute<br> We are bringing you to the homepage</span>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex';
  export default {
    computed: {
    ...mapGetters({
        UserLogin: "AuthController/user",
      })
    },
    created () { 
      /*console.log(111)
      if(this.UserLogin) {
        return this.$router.push(`/v2/dashboard`)
      }
      else {
        this.$router.push(`/login`)
      }*/
    }
  }
</script>